import { BoxIcon, Text } from '#atoms';

import {
  LabelBox,
  ArticleContainer,
  WritingList,
  ArticleItemBox,
  ArticleInfo,
  ImageBox,
  CommentLikeCountBox,
  Line,
  CommentLikeItem,
  WritingContainer,
  AnswerItemBox
} from '#templates/CoachDetailContent/DetailInfo/CoachIntroduce/styles';

import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { axios } from '#api/axios';
import EmptyContent from 'src/refactor_shared/ui/empty-content';
import { useUserInfo } from '#providers/UserInfo';
import recursiveParser from 'src/refactor_shared/lib/recursive-parser';

const Articles = () => {
  const { userInfo } = useUserInfo();
  const { data: informationList } = useQuery({
    queryKey: ['get-information-community-coach-questions'],
    queryFn: async () =>
      await axios.get(`/consumer/exercise/coach/questions/${userInfo?.id}`),
    select: data => data.data,
    enabled: !!userInfo?.id
  });

  const { data: qnaAnswerList } = useQuery({
    queryKey: ['get-qna-community-coach-answers'],
    queryFn: async () => await axios.get('/consumer/qna/answers/coach'),
    select: data => data.data
  });

  return (
    <ArticleContainer>
      <LabelBox>
        <Text textStyle="t3">나의 운동 지식 활동</Text>
      </LabelBox>
      <ArticleAnswers data={qnaAnswerList} />
      <ArticleInsights data={informationList} />
    </ArticleContainer>
  );
};

const ArticleAnswers = ({
  data
}: {
  data: Array<{ content: string; id: string }>;
}) => {
  return (
    <WritingContainer>
      <LabelBox>
        <Text style={{ fontSize: '16px' }}>
          답변{' '}
          <span style={{ color: '#8E899F' }}>{data ? data.length : 0}</span>
        </Text>
        <Link to={'activities/qna'}>
          <BoxIcon type="next-arrow" onlyIcon size={14} />
        </Link>
      </LabelBox>
      <WritingList>
        {data ? (
          data.map(value => (
            <AnswerItemBox key={value.id}>
              <p style={{ color: '#9170F2' }}>A.</p>
              <p
                className="description line-clamp-2"
                dangerouslySetInnerHTML={{ __html: value.content }}
              />
            </AnswerItemBox>
          ))
        ) : (
          <EmptyContent>작성한 운동 가이드가 없습니다.</EmptyContent>
        )}
      </WritingList>
    </WritingContainer>
  );
};

const ArticleInsights = ({ data }: { data: any }) => {
  return (
    <WritingContainer>
      <LabelBox>
        <Text style={{ fontSize: '16px' }}>
          운동 가이드{' '}
          <span style={{ color: '#8E899F' }}>{data ? data.length : 0}</span>
        </Text>
        <Link to={'activities/information'}>
          <BoxIcon type="next-arrow" onlyIcon size={14} />
        </Link>
      </LabelBox>
      <WritingList>
        {data ? (
          data.map((value: any) => (
            <ArticleItemBox key={value.id}>
              <ArticleInfo>
                <div className="w-full">
                  <p className="title">{value.title}</p>
                  <p className="description line-clamp-2 text-ellipsis overflow-hidden whitespace-nowrap">
                    {recursiveParser(value.content)}
                  </p>
                </div>
                {value.image && <ImageBox src={value.image.resizedLink} />}
              </ArticleInfo>
              <div className="pt-5 border-t-1 border-solid border-[#24222a] mt-5">
                <CommentLikeCountBox>
                  <CommentLikeItem>
                    <BoxIcon type="comment-sharp" onlyIcon size={14} />
                    <p>{value._count?.comments}</p>
                  </CommentLikeItem>
                  <CommentLikeItem>
                    <BoxIcon type="thumb-up-alt" onlyIcon size={14} />
                    <p>{value._count?.likes}</p>
                  </CommentLikeItem>
                </CommentLikeCountBox>
              </div>
            </ArticleItemBox>
          ))
        ) : (
          <EmptyContent>작성한 운동 가이드가 없습니다.</EmptyContent>
        )}
      </WritingList>
    </WritingContainer>
  );
};

export default Articles;
